import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { InvoiceStatusWidgetView, InvoiceStatusWidget } from '@feature/invoice-status/invoice-status-widget-types';
import * as actions from '@feature/invoice-status/actions/invoice-status-widget';

export const invoiceStatusWidgetFeature = 'invoiceStatusWidget';

export const adapter = createEntityAdapter<InvoiceStatusWidget>();

export interface State extends EntityState<InvoiceStatusWidget> { };

export const INITIAL_STATE: State = adapter.getInitialState();

export const INITIAL_INSTANCE_STATE: InvoiceStatusWidget = {
  id: undefined,
  loading: true,
  currentView: 'InvoiceStatusVolume',
  data: undefined,
  currency: undefined,
  drillDownActive: false,
  drillDownLabel: undefined,
  drillDownStatus: undefined,
};

const invoiceStatusWidgetReducer = createReducer(
  INITIAL_STATE,
  on(actions.apiLoad, (state, { widgetId }) => {
    let item: InvoiceStatusWidget = state.entities[widgetId] || INITIAL_INSTANCE_STATE;
    item = { ...item, ...{ id: widgetId, loading: true } };
    return adapter.upsertOne(item, state);
  }),

  on(actions.enterDrillDown,
    (state, { widgetId, invoiceStatus }) => {
      const update = {
        id: widgetId,
        changes: {
          drillDownStatus: invoiceStatus,
          currentView: 'InvoiceStatusTable' as InvoiceStatusWidgetView,
          drillDownLabel: `Showing Invoices of status ${invoiceStatus}`,
          drillDownActive: true,
        }
      };
      return adapter.updateOne(update, state);
    }),

  on(actions.exitDrillDown,
    (state, { widgetId }) => {
      const update = {
        id: widgetId,
        changes: {
          drillDownStatus: null,
          drillDownActive: false,
          drillDownLabel: null,
        }
      };
      return adapter.updateOne(update, state);
    }),

  on(actions.apiLoadComplete,
    (state, { widgetId, data }) => {
      const update = {
        id: widgetId,
        changes: {
          data: data,
          loading: false,
        }
      };
      return adapter.updateOne(update, state);
    }),

  on(actions.setView,
    (state, { widgetId, view }) => {
      const update = {
        id: widgetId,
        changes: {
          currentView: view
        }
      };
      return adapter.updateOne(update, state);
    }),

  on(actions.setCurrency,
    (state, { widgetId, currency }) => {
      const update = {
        id: widgetId,
        changes: {
          currency: currency
        }
      };
      return adapter.updateOne(update, state);
    }),

);

export function reducer(state: State | undefined, action: Action) {
  return invoiceStatusWidgetReducer(state, action);
}

